import { Injectable, OnInit } from '@angular/core';
import { LogService } from './logging.service';
import { NgRedux } from '@angular-redux/store';
import { IAppState, IAppConfig } from '../../../app/store';
import { CookieService } from 'ngx-cookie-service';
import { BaseDao } from './../daos/base.dao';
import {
  Actions
} from '../../store/actions';
import {AppAction} from '../../store/interfaces/IAppState';

@Injectable()
export class UserService {
  private _appConfig;

  constructor(
    private _log: LogService,
    private _ngRedux: NgRedux<IAppState>,
    private _cookieService: CookieService,
    private _actions: Actions,
    private _dao: BaseDao
  ) {
    this._appConfig = _ngRedux.getState().appConfig as IAppConfig;
  }

  me = () => {
    const url = this._appConfig.statusDAO.url;
    const ssoToken = this._cookieService.get('X-IHG-SSO-TOKEN');
    const {
      apiKey,
      interval,
      retry,
      timeout
    } = this._appConfig.statusDAO;

    return this._dao.get(false, apiKey, interval, retry, timeout, url, ssoToken)
      .subscribe(
        me => { this._actions.dispatchMe(AppAction.GET_ME, me) },
        error => { this._actions.dispatchMe(AppAction.GET_ME, {}) },
        () => { this._log.info('me finally()') }
      )
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/services/user.service.ts